import React, { useState } from 'react';

// styles 
import styles from "./ReminderPortal.module.css"

import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import opacity from "react-element-popper/animations/opacity"

const ReminderTimePicker = (props) => {
    const [openMenu, setOpenMenu] = useState(false);

    const handleChange = async (value) => {
        //تغییرات روی تاریخ رو اینجا اعمال کنید
        if (props.addCall) {
            props.setData((prev) => {
                return { ...prev, callTime: value };
            });
            if (openMenu === true) {
                setOpenMenu(false)
            }
        } else {
            props.setData((prev) => {
                return { ...prev, hourValue: value };
            });
            if (openMenu === true) {
                setOpenMenu(false)
            }
        }

        // const userDate = `${value.hour}-${value.minute}`
        // console.log(userDate)
        // const userDate = await `${value.year}-${value.month.number}-${value.day} ${value.hour}:${value.minute}:${value.second}`
    }

    return (
        <>
            <style type="text/css">
                {`
                .rmdp-time-picker div input {
                   background: transparent;
                }

                .rmdp-arrow {
                    border-color: #D9D9D9 !important;
                }
                `}
            </style>


            <div className={`d-flex align-items-start justify-content-center flex-column my-0 ${props.addCall ? "" : "w-100"}`}>
                <div className={`mb-2 ${styles.input_top_title}`}>
                    انتخاب زمان
                </div>
                <DatePicker
                    value={props.data}
                    onChange={handleChange}
                    disableDayPicker
                    format="HH:mm"
                    plugins={[
                        <TimePicker hideSeconds />
                    ]}
                    calendar={persian}
                    locale={persian_fa}
                    calendarPosition="bottom-center"
                    animations={[opacity()]}
                />
            </div>
        </>
    );
};

export default ReminderTimePicker;